import { IAnalyticsConfiguration, IAnalyticsProvider, IViewItemAnalytics, IAddToCartAnalytics } from '../types';

interface IGA4Config {
  send_page_view: boolean;
  page_location: string;
  user_id?: number;
}

class GA4Provider implements IAnalyticsProvider {
  readonly isEnabled: boolean;

  readonly userId: number;

  readonly measurementIds: string[];

  constructor({ userId, isEnabled, measurementIds }: IAnalyticsConfiguration) {
    this.isEnabled = isEnabled;
    this.userId = userId;
    this.measurementIds = measurementIds;
  }

  init() : void {
    const config: IGA4Config = {
      send_page_view: true,
      page_location: getPageLocationWithoutQueryString(),
    };

    if (this.userId > 0) {
      config.user_id = this.userId;
    }

    this.send('js', new Date());

    this.measurementIds.forEach((measurementId) => {
      if (!this.isEnabled) return;

      this.send('config', measurementId, config);
    });
  }

  trackPurchase(orderData: any) : void {
    if (!this.isEnabled) return;

    this.send('event', 'purchase', orderData);
  }

  trackViewItem(viewItemData: IViewItemAnalytics) : void {
    if (!this.isEnabled) return;

    this.send('event', 'view_item', viewItemData);
  }

  trackAddToCart(addToCartData: IAddToCartAnalytics) : void {
    if (!this.isEnabled) return;

    this.send('event', 'add_to_cart', addToCartData);
  }

  private send(...args: (any)[]) {
    if (!this.isEnabled) {
      return;
    }
    window.gtag(...args);
  }
}

function getPageLocationWithoutQueryString() : string {
  return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
}

export default GA4Provider;
